import { getRequest } from '../services/requestHandler';
import { AppUserForDropdown } from '../models';

export const getAppUsersForDropdown = async () => {
  const url = `appuser/getAppUsersForDropdown?filter=&showAll=true`;

  const response = await getRequest<AppUserForDropdown>('GetAppUsersForDropdown', url);
  return response;
};
